// Browser-only half of the export pipeline — deliberately split out of
// xlsxReport.ts (which stays pure/DOM-free) so a plain Node test script can
// import the sheet-building/style helpers directly (see
// scripts/test-unit-export.ts) without dragging in exporters.ts's DOM
// usage (document/HTMLCanvasElement) or write-excel-file's Blob-typed
// browser return type. Only src/views/UnitHealth.tsx (a browser component)
// should import from this file — report-content modules like
// src/lib/reports/unitExport.ts must only ever import from xlsxReport.ts.

import { downloadBlob } from '../exporters.ts';
import { REPORT_FONT_FAMILY, type ReportSheet } from './xlsxReport.ts';

/** Renders `sheets` to an .xlsx Blob via write-excel-file's browser build
 *  (lazy-loaded, same pattern as exporters.ts's own downloadXlsx()). */
export async function buildReportWorkbookBlob(sheets: ReportSheet[]): Promise<Blob> {
  const writeXlsxFile = (await import('write-excel-file/browser')).default;
  const sheetArgs = sheets.map((s) => ({
    sheet: s.name,
    data: s.rows,
    columns: s.columns,
    stickyRowsCount: s.stickyRowsCount,
    orientation: s.orientation,
  }));
  return writeXlsxFile(sheetArgs as never, { fontFamily: REPORT_FONT_FAMILY, fontSize: 11 }).toBlob();
}

export async function downloadReportWorkbook(sheets: ReportSheet[], filename: string): Promise<void> {
  const blob = await buildReportWorkbookBlob(sheets);
  downloadBlob(blob, filename);
}
